import { Box, Typography } from '@material-ui/core';

export type ChartDetail = {
  color: string;
  label: string;
  value: number;
  percentage: number;
};

function renderLegend(details: ChartDetail[]) {
  return details.map((detail, index) => (
    <Box
      key={`${detail.label}-${index}`}
      component="div"
      style={{
        display: 'flex',
        alignItems: 'center',
        marginBottom: '8px',
      }}
    >
      <Box
        component="div"
        style={{
          width: '12px',
          height: '12px',
          backgroundColor: detail.color,
          marginRight: '8px',
          borderRadius: '2px',
        }}
      />
      <Typography variant="body2">
        {detail.label} ({detail.value} - {detail.percentage}%)
      </Typography>
    </Box>
  ));
}

export interface OverviewComponentProps {
  chartDetails: ChartDetail[];
}

export const OverviewComponent = (props: OverviewComponentProps) => {
  return (
    <Box
      component="div"
      style={{
        display: 'flex',
        flexDirection: 'column',
        marginTop: '20px',
        overflowY: 'auto',
      }}
    >
      {renderLegend(props.chartDetails)}
    </Box>
  );
};
